<template>
    <v-card rounded elevation="1" class="bg">
        <v-card-title> Résumé </v-card-title>
        <v-card-text
            v-for="(invoice, key) in invoices"
            :key="key"
            class="d-flex justify-space-between"
        >
            <div>
                <strong>{{ invoice.title }}</strong>
            </div>
            <div>{{ newCommonFormatCurrency(invoice.amountSigned) }}</div>
        </v-card-text>
        <v-card-text v-if="invoices.length !== 1" class="d-flex justify-space-between">
            <div>
                <strong>Total</strong>
            </div>
            <div>{{ newCommonFormatCurrency(totalAmountSigned) }}</div>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between">
            <v-btn-icon
                variant="elevated"
                size="x-small"
                icon="$cloud_download"
                color="primary"
                @click="downloadDocument()"
            >
            </v-btn-icon>
            <v-chip
                v-if="type === 'devis' && data.isSignature && data.isAlreadySigned"
                label
                color="primary"
                variant="flat"
                size="small"
                >Signé <v-icon size="x-small" right class="ml-2">$fa-check</v-icon></v-chip
            >
            <v-btn
                v-else-if="type === 'devis' && data.isSignature"
                variant="elevated"
                size="small"
                @click="askForSignature()"
                >Signer le devis</v-btn
            >
            <v-btn
                v-else-if="
                    type === 'facture' && data.isPaymentLink && data.accountingLines.length == 1
                "
                @click="openPaymentLink()"
                variant="elevated"
                size="small"
                >Payer {{ data.accountingLines.length > 1 ? "les" : "la" }} facture{{
                    data.accountingLines.length > 1 ? "s" : ""
                }}</v-btn
            >
        </v-card-actions>
    </v-card>
</template>

<script lang="ts">
import INVOICE_SIGNATURE from "@/graphql/invoice/InvoicePublicViewSignature.gql";
import INVOICE_PAYMENT from "@/graphql/invoice/InvoiceCreatePaymentLink.gql";

import { newCommonFormatCurrency } from "@/../../backend/src/common/services/mathServices";

import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component
export class PublicInvoiceResume extends Vue {
    @Prop({ default: "facture" }) type: string;
    @Prop() documentSignedUrl: string;
    @Prop() invoices: any;
    @Prop() data: any;

    get totalAmountSigned() {
        let total = 0;

        for (const invoice of this.invoices) {
            total += invoice.amountSigned;
        }
        return total;
    }

    async downloadDocument() {
        window.open(this.documentSignedUrl, "_blank");
    }

    async askForSignature() {
        if (!this.data.signatureUrl) {
            let result = await this.$apollo.mutate({
                mutation: INVOICE_SIGNATURE,
                variables: {
                    invoiceId: this.data.invoiceId,
                    title: this.data.invoiceNumber,
                    receivers: this.data.receivers,
                },
            });
            if (
                !result.data?.invoicePublicViewSignTransaction?.alreadySigned &&
                result.data.invoicePublicViewSignTransaction.signUrl
            ) {
                window.location.href = result.data.invoicePublicViewSignTransaction.signUrl;
            }
        } else {
            window.location.href = this.data.signatureUrl;
        }
    }

    async openPaymentLink() {
        const result = await this.$apollo.mutate({
            mutation: INVOICE_PAYMENT,
            variables: {
                data: this.data,
                // title: this.data.invoiceNumber,
                // receivers: this.data.receivers,
            },
        });
        window.location.href = result.data.invoiceCreatePaymentLink.url;
    }
}

export default toNative(PublicInvoiceResume);
</script>

<style scoped>
.bg {
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 10px !important;
}
</style>
